import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Car, ArrowRight, ArrowLeft, Clock, CheckCircle2 } from "lucide-react";
import { api } from "../../lib/api";

/**
 * Registro Live Assegnazione Veicoli
 * Tabella in primo piano con stato movimentazione flotta
 */
export default function LiveFleetTable() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    api.get("/dashboard/live-fleet").then((r) => { setRows(r.data); setLoading(false); });
  };
  useEffect(() => {
    load();
    const t = setInterval(load, 30000); // refresh every 30s
    return () => clearInterval(t);
  }, []);

  const formatDateTime = (iso) => {
    if (!iso) return "—";
    try {
      const d = new Date(iso);
      return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
    } catch { return iso; }
  };

  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}
      className="glass rounded-2xl overflow-hidden border border-white/10" data-testid="live-fleet">
      <div className="flex items-center justify-between px-6 py-4 border-b border-white/5">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-[#ff0033]/15 border border-[#ff0033]/30 flex items-center justify-center">
            <Car size={16} className="text-[#ff5577]" />
          </div>
          <div>
            <div className="font-display text-lg font-bold uppercase tracking-tight">Registro Live Assegnazione</div>
            <div className="text-[10px] text-white/40 uppercase tracking-widest">Movimentazione flotta in tempo reale</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-[10px] uppercase tracking-widest px-2 py-1 rounded-full bg-emerald-500/15 text-emerald-300 border border-emerald-500/30 inline-flex items-center gap-1">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" /> Live
          </span>
          <span className="text-[10px] text-white/45">{rows.length} totali</span>
        </div>
      </div>

      <div className="overflow-auto">
        <table className="w-full text-sm">
          <thead className="bg-white/[0.02] text-[10px] uppercase tracking-widest text-white/45 sticky top-0">
            <tr>
              <th className="text-left px-4 py-3">Targa</th>
              <th className="text-left px-4 py-3">Modello</th>
              <th className="text-left px-4 py-3">Conducente / Cliente</th>
              <th className="text-left px-4 py-3"><span className="inline-flex items-center gap-1"><ArrowRight size={10} className="text-emerald-400" /> Uscita</span></th>
              <th className="text-left px-4 py-3"><span className="inline-flex items-center gap-1"><ArrowLeft size={10} className="text-[#ff5577]" /> Entrata</span></th>
              <th className="text-right px-4 py-3">Stato</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr><td colSpan={6} className="text-center p-8 text-white/40">Caricamento…</td></tr>
            )}
            {!loading && rows.length === 0 && (
              <tr><td colSpan={6} className="text-center p-8 text-white/40">Nessuna assegnazione attiva</td></tr>
            )}
            {rows.map((r) => (
              <tr key={r.contract_id} className="border-t border-white/5 hover:bg-white/[0.02] transition-colors" data-testid={`row-${r.targa}`}>
                <td className="px-4 py-3">
                  <span className="font-mono font-bold text-white bg-white/[0.04] px-2.5 py-1 rounded-md text-xs uppercase tracking-wider">{r.targa}</span>
                </td>
                <td className="px-4 py-3 text-white/80 text-xs">{r.modello}</td>
                <td className="px-4 py-3 font-display font-bold uppercase tracking-tight text-sm">{r.cliente}</td>
                <td className="px-4 py-3 text-xs font-mono text-emerald-300">{formatDateTime(r.data_uscita)}</td>
                <td className="px-4 py-3 text-xs font-mono text-[#ff5577]">{formatDateTime(r.data_entrata)}</td>
                <td className="px-4 py-3 text-right">
                  {r.stato === "in_corso" ? (
                    <span className="text-[10px] uppercase tracking-widest px-3 py-1 rounded-full bg-[#ff0033]/15 text-[#ff5577] border border-[#ff0033]/40 inline-flex items-center gap-1.5">
                      <Clock size={9} className="animate-pulse" /> In corso
                    </span>
                  ) : (
                    <span className="text-[10px] uppercase tracking-widest px-3 py-1 rounded-full bg-emerald-500/15 text-emerald-300 border border-emerald-500/30 inline-flex items-center gap-1.5">
                      <CheckCircle2 size={9} /> Rientrata
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </motion.div>
  );
}
